import { render, staticRenderFns } from "./Mint2.vue?vue&type=template&id=7893825b&scoped=true&"
import script from "./Mint2.vue?vue&type=script&lang=ts&"
export * from "./Mint2.vue?vue&type=script&lang=ts&"
import style0 from "./Mint2.vue?vue&type=style&index=0&id=7893825b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7893825b",
  null
  
)

export default component.exports